'use client';

// Colors
import {
	Checkbox,
	Radio,
	type MantineThemeOverride,
} from '@mantine/core';

// Fonts
import colors from './colors';

export const breakpoints = {
	/** 1024px */
	tablet: '64rem',

	/** 1280px */
	laptop: '80rem',

	/** 1440px */
	desktop: '90rem',

	/** 1920px */
	largeScreen: '120rem',
} as const;

export const isBreakpoint = (
	bp: string | number
): bp is keyof typeof breakpoints =>
	typeof bp === 'string' &&
	['tablet', 'laptop', 'desktop', 'largeScreen'].includes(
		bp
	);

export const spacing = {
	/** 8px */
	xxs: '0.5rem',

	/** 12px */
	xs: '0.75rem',

	/** 16px */
	sm: '1rem',

	/** 24px */
	md: '1.5rem',

	/** 32px */
	lg: '2rem',

	/** 42px */
	xl: '2.625rem',

	/** 64px */
	xxl: '4rem',

	/** 88px */
	xxxl: '5.5rem',
} as const;

export const fontSizes = {
	/** 10px */
	xxs: '0.625rem',

	/** 12px */
	xs: '0.75rem',

	/** 14px */
	sm: '0.875rem',

	/** 16px */
	md: '1rem',

	/** 18px */
	lg: '1.125rem',

	/** 20px */
	xl: '1.25rem',
} as const;

export const radius = {
	sm: '12px',
	/** 24px */
	md: '24px',

	/** 32px */
	lg: '32px',

	/** 48px */
	xl: '48px',
};

const base = {
	/* -------------------------------------------------------------------------- */
	/*                                 Dimensions                                 */
	/* -------------------------------------------------------------------------- */

	radius,

	breakpoints,

	spacing,

	/* -------------------------------------------------------------------------- */
	/*                             Colors (invariant)                             */
	/* -------------------------------------------------------------------------- */

	colors,

	/* -------------------------------------------------------------------------- */
	/*                                 Typography                                 */
	/* -------------------------------------------------------------------------- */

	fontFamily: `InterDisplay-Regular`,
	fontSizes,
	components: {
		Checkbox: Checkbox.extend({
			defaultProps: {
				color: 'var(--mantine-color-igluPrimary-9)',
				variant: 'outline',
				radius: '4px',
				size: 'xs',
			},
		}),
		Radio: Radio.extend({
			defaultProps: {
				color: 'var(--mantine-color-igluPrimary-9)',
				variant: 'outline',
			},
		}),
	},
} satisfies MantineThemeOverride;

export default base;
